import React from 'react';
import { Help } from '@procore/core-icons';
import styled from 'styled-components';
import {
  Box,
  Grid,
  OverlayTrigger,
  Typography,
  useI18nContext,
  Button,
  colors,
} from '@procore/core-react';
import { DropdownMenu, UnstyledLink } from '@/react/styles';
import { NAVIGATION_MENU_ITEMS } from '@/react/consts';

const InfoButton = styled(Button)`
  border-radius: 100px;
  background-color: ${colors.gray96};
`;

const MenuTile = styled(Box)`
  background-color: ${colors.gray96};
  max-width: 132px;
  height: 124px;
  border-radius: 8px;
  text-align: center;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${colors.gray90};
  }
`;

const MenuContainer = styled(Grid)`
  width: 272px;
  max-width: 272px;
`;

const SupportMenu = () => {
  const i18n = useI18nContext();

  const visibleMenuItems = NAVIGATION_MENU_ITEMS.filter(
    (item) => !item.disabled
  );

  const renderMenuItem = (item, key) => (
    <Grid.Col key={key} colWidth={6}>
      <UnstyledLink
        href={item.href}
        target="_blank"
        data-testid={`support-${item.testid}`}
      >
        <MenuTile
          display="flex-column"
          gap="sm"
          padding="sm"
          alignItems="center"
          justifyContent="center"
        >
          {item.icon}
          <Typography intent="small" weight="semibold">
            {i18n.t(item.label)}
          </Typography>
        </MenuTile>
      </UnstyledLink>
    </Grid.Col>
  );

  const renderMenu = (
    <DropdownMenu>
      <MenuContainer gutterX="sm" gutterY="sm">
        <Grid.Row>
          {visibleMenuItems.map((item, index) =>
            renderMenuItem(item, `menu-item-${index}`)
          )}
        </Grid.Row>
      </MenuContainer>
    </DropdownMenu>
  );

  return (
    <Box data-testid="support-menu" display="flex">
      <OverlayTrigger placement="bottom" overlay={renderMenu}>
        <InfoButton
          icon={<Help />}
          size="lg"
          aria-label={i18n.t('ariaLabels.supportButton')}
          variant="secondary"
        />
      </OverlayTrigger>
    </Box>
  );
};

export default SupportMenu;
